// OLA - Offline Leads Actions
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Rest } from "../../Rest";
export class OlaApiLegacy extends Rest {
    constructor(baseUrl, tenantToken, ciamToken, userUuid) {
        super(baseUrl);
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.userUuid = userUuid;
        this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
        this.ciamToken && this.setCommonHeader("X-DES-CONSUMER-IAM-TOKEN", this.ciamToken);
    }
    getOfflinePurchases() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(`/consumers/${this.userUuid}/actions/purchase`, {
                method: "GET",
            }, true);
        });
    }
    validateHash(hash) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(`/consent/validate/${hash}`, {
                method: "POST",
            }, true);
        });
    }
}
//# sourceMappingURL=OlaApiLegacy.js.map